<template>
  <div aria-live="assertive" class="notifications-container">
    <div class="notifications-content">
      <div class="notification" :class="[n.level]" v-for="n of notifications" :key="n.id">
        <div class="p-4">
          <div class="flex items-start">
            <div class="flex-shrink-0">
              <svg
                class="icon h-6 w-6 text-red-400"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                stroke="none"
                viewBox="0 0 24 24"
                aria-hidden="true"
                v-if="n.level === levels.ERROR"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clip-rule="evenodd"
                />
              </svg>
              <svg
                class="icon h-6 w-6 text-green-400"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
                v-if="n.level === levels.SUCCESS"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <svg
                class="icon w-6 h-6 text-blue-400"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
                stroke="none"
                fill="currentColor"
                v-if="n.level === levels.INFO"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </div>
            <div class="text-content">
              <p class="headline">{{ n.headline }}</p>
              <p class="details">{{ n.details }}</p>
            </div>
            <div class="ml-4 flex-shrink-0 flex">
              <button class="close" @click="remove(n.id)">
                <span class="sr-only">Close</span>
                <!-- Heroicon name: solid/x -->
                <svg
                  class="h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { NOTIFICATION_LEVEL } from '@/helpers/constants';

export default {
  name: 'Notification',

  data() {
    return {
      notifs: [],
    };
  },
  computed: {
    ...mapState({
      notifications: (state) => state.notifications.notifications,
    }),
    levels() {
      return NOTIFICATION_LEVEL;
    },
  },

  methods: {
    remove(id) {
      this.$store.commit('notifications/remove', id);
    },
  },
};
</script>

<style scoped>
.notifications-container {
  @apply z-50 fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start;
}

.notifications-content {
  @apply w-full flex flex-col items-center space-y-4 sm:items-end;
}

.notification {
  @apply max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden;
}

.text-content {
  @apply ml-3 w-0 flex-1 pt-0.5;
}

.headline {
  @apply text-sm font-medium text-gray-900;
}

.details {
  @apply mt-1 text-sm text-gray-500;
}

.close {
  @apply p-0 border-0 shadow-none bg-white rounded-md inline-flex text-gray-400 cursor-pointer hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500;
}
</style>